import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-dental-social-history",
  templateUrl: "./dental-social-history.component.html",
  styleUrls: ["./dental-social-history.component.scss"],
})
export class DentalSocialHistoryComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
